import { Component, OnInit, DoCheck, HostListener } from '@angular/core';
import { Router } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { Observable } from "rxjs/Observable";
// import { map,startWith } from "rxjs/operators";

import { InstitutionsInfoModel } from "app/shared/models/instituitions-info.model";
import { BaseFormValidation } from "app/shared/validators/base-form-validation";
import { EnrollmentProgramsService, EnrollmentService } from "app/shared/services/enrollment-programs.service";
import { SecurityService } from "app/security/security.service";
import { ContractsService } from "app/shared/services/contracts.service";
import { SelectListItemModel } from "app/shared/models/select-list-item.model";
import { StudentPayrollRequest } from "app/shared/models/payment-method-select.model";
import { PaymentMethods } from "app/shared/enums/payment-methods-select.enum";
import { EnrolleeAddress } from "app/shared/models/enrollee-address.model";

@Component({
  selector: 'online-app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
})
export class PaymentMethodsComponent extends BaseFormValidation implements OnInit, DoCheck {

  @HostListener('paste',['$event'])
    blockPasteAction(e: ClipboardEvent){
      e.preventDefault();
      this.toastr.warning("Pasting has been disabled for this form.")
  }
  @HostListener('copy',['$event'])
    blockCopyAction(e: ClipboardEvent){
      e.preventDefault();
      this.toastr.warning("Copying has been disabled for this form.")
  }
  @HostListener('cut',['$event'])
    blockCutAction(e: ClipboardEvent){
      e.preventDefault();
      this.toastr.warning("Cutting has been disabled for this form.")
  }

  constructor(private fb: FormBuilder,
    private router: Router,
    private toastr: ToastsManager,
    private secService: SecurityService,
    private enrollmentService: EnrollmentService,
    private programsService: EnrollmentProgramsService,
    private contractService: ContractsService) {
      super();

      this.enrollmentService.getEnrolleeAddress(this.secService.currentUserInfo.id).subscribe(data => this.address = data);

      this.enrollmentService.getEnrolleePaymentMethod(this.secService.currentUserInfo.id).subscribe(method => {
        this.studentPayments = method.paymentOptionId != null? method : null;
      });
  
      this.programsService.getPaymentSelectExpirationDate().subscribe(expirationDate => {
        var today = new Date();
        this.paymentSelectDeadline = today.valueOf() > expirationDate.valueOf()  ? true : false;
      });

      // this.programsService.getBankList().subscribe(data => this.bankList = data)

      Observable.forkJoin(this.contractService.getContractInfo(
        this.secService.currentUserInfo.id),
        this.programsService.getPaymentMethodsLookup())
        .subscribe(data => {
          this.contractType = data[0].contractJobType
          let refCode:string = data[0].referralCode;
          let providerAccess = sessionStorage.getItem('isProviderAccess') != null &&  sessionStorage.getItem('isProviderAccess') == 'true';
          this.paymentMethodsList = <SelectListItemModel[]>data[1];

          if((refCode.includes("S124") || refCode.includes("IN002") || refCode.includes("IN008"))
            && providerAccess == false)
          {
            this.tempPaymentMethodsList = this.paymentMethodsList;
          }
          else if(this.contractType == "Hourly"){
            this.tempPaymentMethodsList = this.paymentMethodsList.filter(i => i.name != this.paymentMethodEnumTypes.DirectDeposit);
          }
          else{
            this.tempPaymentMethodsList = this.paymentMethodsList.filter(i => i.name != "Direct Deposit");
          }
        });

        let enrolleeYears = new Date(this.secService.currentUserInfo.dateOfBirth).valueOf(); 
        let currentDate = new Date().valueOf();
        let oneDay = 24 * 60 * 60 * 1000;
        this.isOver13 = Math.round(Math.abs(currentDate - enrolleeYears) / oneDay) >= 4745;
  }

  protected paymentMethodEnumTypes = PaymentMethods;
  protected accountTypes: string[] = ["Checking", "Savings"]
  protected contractType: string;
  protected selectedOption: string = null;

  protected paymentMethodForm: FormGroup;
  protected paymentMethodsList: SelectListItemModel[];
  protected tempPaymentMethodsList: SelectListItemModel[];
  protected studentPayments: StudentPayrollRequest;
  protected address: EnrolleeAddress;
  protected isOver13: boolean = false;
  // protected bankList: InstitutionsInfoModel[];
  // protected filteredOptions:Observable<InstitutionsInfoModel[]>;
  
  protected paymentSelectDeadline: boolean = false;
  

  protected get PaymentMethodMessage(): Observable<string>{
    return this.programsService.getPaymentMethodMessage();
  }

  protected get DebitCardAckMessage(): Observable<string>{
    return this.programsService.getDebitCardAckStatement();
  }

  protected get ProgramEmail(): Observable<string>{
    return this.programsService.getProgramEmail();
  }

  protected get PaymentOption(): Observable<string>{
    if((this.paymentMethodsList == null && this.paymentMethodsList == undefined) ||
     (this.studentPayments.paymentOptionId == null && this.studentPayments.paymentOptionId == undefined))
      return Observable.of('');
    var filteredOptions = this.paymentMethodsList.find(p => p.value == this.studentPayments.paymentOptionId.toString());
    if(filteredOptions == undefined){
      return Observable.of('')
    }
    return Observable.of(filteredOptions.name);
  }

  ngOnInit() {
    this.paymentMethodForm = this.generatePaymentForm(null); 
  }

  ngDoCheck(): void {
  //   if(this.paymentMethodForm.get('bankName') != null){
  //     this.filteredOptions = this.paymentMethodForm.get('bankName').valueChanges
  //     .pipe(startWith(''), map(val => this.filter(val)));
  //   }
  }

  protected save(form: FormGroup){
    // console.log(form);
    var model = new StudentPayrollRequest();

    model.onlineEnrollmentId = form['onlineEnrollmentId'];
    model.paymentOptionId = form['paymentOptionId'];

    if(this.selectedOption == this.paymentMethodEnumTypes.DirectDeposit){
      let encodedRoutNum = btoa(form['routingNumberConfirm']);
      let encodedAccNumb = btoa(form['accountNumberConfirm']);

      model.accountType = form['accountType'];
      model.bankName = form['bankName'];
      model.routingNumber = encodedRoutNum;
      model.accountNumber = encodedAccNumb;
    }
    else if(this.selectedOption == this.paymentMethodEnumTypes.DebitCard){
      model.debitCardAckFlag = form['debitCardAckFlag']
    }

    this.enrollmentService.addPayrollMethod(model).subscribe(() => {
      this.toastr.success("Payment Method Added!");
      // location.reload(false)
      // this.studentPayments = model;
      this.router.navigate(['/thankyou']).then((e) => {
        if (e) {
              this.secService.logout().subscribe();
        }
  });
    });
  }

  generatePaymentForm(option: string, optionId?: number){
    if(option == this.paymentMethodEnumTypes.Check){
      return this.fb.group({
        onlineEnrollmentId: this.secService.currentUserInfo.id,
        paymentOptionId: [optionId, Validators.required],
      })
    }
    else if(option == this.paymentMethodEnumTypes.DebitCard){
      return this.fb.group({
        onlineEnrollmentId: this.secService.currentUserInfo.id,
        paymentOptionId: [optionId, Validators.required],
        debitCardAckFlag: [null, Validators.required],
      });
    }
    else if(option == this.paymentMethodEnumTypes.DirectDeposit){
      return this.fb.group({
        onlineEnrollmentId: this.secService.currentUserInfo.id,
        paymentOptionId: [optionId, Validators.required],
        bankName: [null, Validators.required],
        accountType: [null, Validators.required],
        accountNumber: [null, Validators.compose([Validators.required, 
          Validators.minLength(5), Validators.maxLength(17)])],
        accountNumberConfirm: [null, Validators.compose([Validators.required, 
          Validators.minLength(5), Validators.maxLength(17)])],
        routingNumber: [null, Validators.compose([Validators.required, 
          Validators.minLength(5), Validators.maxLength(9)])],
        routingNumberConfirm: [null, Validators.compose([Validators.required, 
          Validators.minLength(5), Validators.maxLength(9)])],
      }, {validator: [this.checkIfAccountMatch('accountNumber','accountNumberConfirm'), 
        this.checkIfRoutingMatch('routingNumber','routingNumberConfirm')]
      });
    }
    else{
      return this.fb.group({
        paymentOptionId: [optionId, Validators.required]
      });
    }
  }

  checkIfAccountMatch(bankNumber1: string, bankNumber2: string){
    return(group: FormGroup) => {
      let verifyBank1Control = group.controls[bankNumber1],
        verifyBank2Control = group.controls[bankNumber2]

        if(verifyBank2Control === null || verifyBank2Control.value == '')
          verifyBank2Control.setErrors({required: true});
        else if(verifyBank1Control.value !== verifyBank2Control.value)
          verifyBank2Control.setErrors({accountMismatch: true});
        else
          verifyBank2Control.setErrors(null);
    }
  }

  checkIfRoutingMatch(routingNumber1: string, routingNumber2: string){
    return(group: FormGroup) => {
      let verifyRouting1Control = group.controls[routingNumber1],
        verifyRouting2Control = group.controls[routingNumber2]

      if(verifyRouting2Control === null || verifyRouting2Control.value == '')
        verifyRouting2Control.setErrors({required: true})
      else if(verifyRouting1Control.value !== verifyRouting2Control.value)
        verifyRouting2Control.setErrors({routingMismatch: true});
      else
        verifyRouting2Control.setErrors(null)
    }
  }

  onPaymentSelectChange(v){
    if(v != null){
      if(v == "Incentive"){

        return;
      }
      else{
        this.selectedOption = this.paymentMethodsList.find(i => i.value == v).name;
        this.paymentMethodForm = this.generatePaymentForm(this.selectedOption, v)
      }
    }
  }

  // filter(value: string){
  //   if(value.length > 3){
  //     let tempSearch = this.bankList.filter(bl => bl.financiaL_INSTITUTION
  //       .indexOf(value.toUpperCase()) >= 0).slice(0, 100);
      
  //     if(tempSearch.length > 0){
  //       // console.log('Value from current list', tempSearch);
  //       return tempSearch;
  //     }
  //     else{
  //       var searchVal;
  //       this.programsService.getBankList(value).subscribe(data => {
  //         searchVal = data
  //       });
  //       console.log('Search Value from API', searchVal)
  //       return searchVal;
  //     }      
  //   }
  //   else{
  //     return this.bankList;
  //   }
  // }

}


// WEBPACK FOOTER //
// ./src/app/additional-resources/payment-methods/payment-methods.component.ts